import { VehicleInfo } from "../../queries/useGetVehicleInfo";

export const shouldRenderVisualizer = (
  vehicleInfo?: VehicleInfo,
  partCount?: number
): boolean => {
  return Boolean(
    vehicleInfo?.vehicleVisualizerForegroundImageUrl &&
      vehicleInfo?.vehicleVisualizerShadowImageUrl &&
      vehicleInfo?.vehicleColourCodes?.length &&
      partCount !== 0
  );
};
